import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const reportRoutes: RouteConfig = {
  path: '/report',
  component: Layout,
  meta: {
    title: 'report',
    icon: 'chart'
    // alwaysShow: true
  },
  children: [
    {
      path: 'balance',
      name: 'Balance Report',
      component: () => import('@/views/report/balanceReport.vue'),
      meta: {
        // title: 'balanceReport',
        title: 'balance',
        icon: 'money',
        activeMenu: '/report/balance'
      }
    },
    {
      path: 'transaction',
      name: 'Transaction Report',
      component: () => import('@/views/report/transactionReport.vue'),
      meta: {
        // title: 'transactionReport',
        title: 'transaction',
        icon: 'example',
        activeMenu: '/report/transaction'
      }
    },
    {
      path: 'rebate',
      name: 'Rebate Report',
      component: () => import('@/views/report/rebate.vue'),
      meta: {
        // title: 'transactionReport',
        title: 'rebate',
        icon: 'excel',
        activeMenu: '/report/rebate'
      }
    },
    {
      path: 'platform',
      name: 'Platform Report',
      component: () => import('@/views/report/platform.vue'),
      meta: {
        title: 'platform',
        icon: 'excel',
        activeMenu: '/report/platform'
      }
    },
    {
      path: 'upparting',
      name: 'Platform Report',
      component: () => import('@/views/report/upparting.vue'),
      meta: {
        title: 'upparting',
        icon: 'international',
        activeMenu: '/report/upparting'
      }
    },
    {
      path: 'agent',
      name: 'Agency commission',
      component: () => import('@/views/report/agent.vue'),
      meta: {
        title: 'agent',
        icon: 'money',
        activeMenu: '/report/agent'
      }
    }
  ]
}

export default reportRoutes
